






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Echart from 'echarts';

@Component({})
export default class Content extends Vue {
  // 登录表单
  @Prop() private id!: string;
  @Prop() private data!: any;
  @Prop() private type: string | undefined;  // 新增yAxis类型，取log值
  @Prop() private logBase: Number | undefined; // log底数
  public chart: any = null;
  public chartData: any = this.data
  public visible: boolean = false;
  public $echarts: any;
  private optionConfig: any = {
    title: {
      textStyle: {
        color: "rgba(83, 88, 117, .7)",
        fontSize: "14",
      },
      top: 20,
      left: -5,
    },
    grid: {
      right: 40,
      left: 60,
      top: 20
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: '#fff',
      padding: 8,
      borderWidth: 1,
      borderColor: 'rgba(83, 88, 17, .15)',
      textStyle: {
        color: '#535875',
        opacity: 0.84,
      },
      axisPointer: {
        type: "line",
        lineStyle: {
          type: "solid",
        },
      },
    }
  };
  private xAxisConfig: any = {
    nameTextStyle: {
      nameLocation: "start",
      nameGap: 100,
      fontSize: 18,
    },
    axisLine: {
      //y轴
      show: false,
      // alignWithLabel: true
      margin: 8, //刻度值离轴线多远的距离
    },
    axisTick: {
      // onZero: false,     //y轴刻度线
      show: false,
    },
    boundaryGap: true,
    axisLabel: {
      //相关轴上的刻度值的设置，show:false，表示不显示轴上的刻度值
      textStyle: {
        //刻度值的字体样式设置
        color: "rgba(83, 88, 117, 0.7)",
      },
      fontSize: 12,
      margin: 8, //刻度值离轴线多远的距离
    },
  };
  private yAxisConfig: any[] = [
    // Y轴左侧
    {
      type: this.type ?? 'value',
      logBase: this.logBase ?? 0,
      nameTextStyle: {
        padding: [0, 60, 10, 0],
        color: "rgba(83, 88, 117, .7)",
        fontSize: "14",
      },
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      splitLine: {
        show: true,
        lineStyle: {
          //x网格线
          type: "dashed",
          color: "#0F1222",
          opacity: 0.15
        },
      },
      axisLabel: {
        //相关轴上的刻度值的设置，show:false，表示不显示轴上的刻度值
        textStyle: {
          //刻度值的字体样式设置
          color: "rgba(83, 88, 117, 0.7)",
        },
        fontSize: 12,
        margin: 8, //刻度值离轴线多远的距离
      },
    },
    // Y轴右侧
    {
      type: "value",
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      splitLine: {
        show: false,
        lineStyle: {
          //x网格线
          type: "dashed",
          color: "#0F1222",
          opacity: 0.15,
        },
      },

      axisLabel: {
        //相关轴上的刻度值的设置，show:false，表示不显示轴上的刻度值
        textStyle: {
          //刻度值的字体样式设置
          color: "rgba(83, 88, 117, 0.7)",
        },
        fontSize: 12,
        margin: 8, //刻度值离轴线多远的距离
        formatter: function (value: number) {
          return `${value * 100}%`;
        },
      },
    },
  ];
  private legendConfig: any = {
    padding: [10, 0, 0, 0],
    type: "plain",
    icon: "roundRect",
    top: 'bottom',
    itemWidth: 16, // 设置宽度
    itemHeight: 8,
    textStyle: {
      color: "#535875",
    },
  };
  private seriesConfig: any[] = [
    {
      type: "line",
      smooth: false,
      symbol: "circle",
      symbolSize: 0,
      itemStyle: {
        color: "#513EFF",
      },
      areaStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(25,102,255,.6)", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#FFFFFF", // 100% 处的颜色
            },
          ],
        },
      },
    },
    {
      type: "line",
      smooth: false,
      symbol: "circle",
      symbolSize: 0,
      itemStyle: {
        color: "#DB6BCF",
      },
      areaStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(219,107,207,.6)", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#FFFFFF", // 100% 处的颜色
            }
          ],
        },
      },
    },
    {
      type: "line",
      smooth: false,
      symbol: "circle",
      symbolSize: 0,
      yAxisIndex: 1,
      lineStyle: {
        color: "#00AA5A", //折线的颜色
        width: "1", //折线粗细
        type: [2,2],
      },
      itemStyle: {
        color: "#00AA5A", //拐点颜色
        borderColor: "#00AA5A", //拐点边框颜色
        borderWidth: 3, //拐点边框大小
      },
    }
  ];
  created(): void {}
  mounted(): void {
    this.chartInit();
    this.$nextTick(() => {
      if (this.chartData) {
        this.chartSetOption();
      }
    });
  }
  chartInit() {
    const container = document.getElementById(this.id);
    this.chart = this.$echarts.init(container);
    window.addEventListener("resize", () => {
      this.chart.resize();
    })
  }
  chartSetOption() {
    if (!this.chartData?.legends || this.chartData?.legends.length == 0){
      return
    }
    let legend: object = Object.assign({
      data: this.chartData?.legends,
    }, this.legendConfig);

    let xAxis: object = Object.assign({
      data: this.chartData?.xaxis.data,
    }, this.xAxisConfig);

    let yAxis: object[] = []
    if (this.chartData?.legends.length == 1) {
      yAxis.push(
          Object.assign({
            name: "" //this.chartData?.legends[0],
          }, this.yAxisConfig[0])
      )
    } else if (this.chartData?.legends.length == 2) {
      yAxis.push(
          Object.assign({
            name: "" //this.chartData?.legends[0] + "/" + this.chartData?.legends[1],
          }, this.yAxisConfig[0])
      )
    } else if (this.chartData?.legends.length == 3) {
      yAxis.push(
          Object.assign({
            name: "" //this.chartData?.legends[0] + "/" + this.chartData?.legends[1],
          }, this.yAxisConfig[0])
      )
      yAxis.push(this.yAxisConfig[1]);
    }

    let series: any[] = []
    for (let i = 0; i < this.chartData?.series.length; i++) {
      series.push(
          Object.assign({
            name: this.chartData?.legends[i],
            data: this.chartData?.series[i].data
          }, this.seriesConfig[i])
      )
    }
    let options: any = Object.assign({
      legend: legend,
      xAxis: xAxis,
      yAxis: yAxis,
      series: series,
    }, this.optionConfig);
    this.chart.setOption(options, true);
  }
  @Watch("data")
  ondataListChange(oldval: any, newval: any) {
    if (newval.length > 0) {
      this.chartData = newval;
    } else {
      this.chartData = oldval;
    }
    // this.eXlist = this.xList;
    // this.fn(false);
    this.chartSetOption()
  }

  /**
   * 登录接口调用
   */
  login(): void {}

  /**
   * 表单检查
   */
  checkForm() {}
}
